// Gray related
export const WHITE_GREY = '#F8F8F8';
export const LIGHT_GREY = '#EDEDED';
export const SILVER_GREY = '#A1A0A0';
export const TEXT_GREY = '#6B6B6D';

// Black and White
export const WHITE = '#ffffff';
export const BLACK = '#000000';
export const MODAL_BLACK = 'rgba(0, 0, 0, 0.6)';
export const OVERLAY_BLACK = 'rgba(0, 0, 0, 0.8)';

// Main Theme
export const BACKGROUND_BLACK = '#414244';
export const BACKGROUND_LIGHT_BLACK = '#666666';
export const BACKGROUND_GREY = '#DADADA';
export const ORANGE = '#FD9059';

// Others
export const GLOOMY = '#CBC6BF';
export const SKIN_ORANGE = '#F6D4C3';
export const PINK = '#FED6D7';
export const LIGHT_GREEN = '#79AA79';
export const RED = '#F4472F';
export const BLUE = '#0B54CC';
export const LIGHT_BLUE = '#17ACFB';
export const ORANGE_OVERLAY = '#FED1BA';
export const TRANSPARENT = 'transparent';
